
    import { mapState } from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import C1FormInput from '@/C1Components/C1FormInput';

    export default {
        name: 'ApplyPersonalInfo',

        components: {
            ValidationProvider,
            C1FormInput,
        },

        data() {
            return {
                firstName: '',
                lastName: '',
                contactNumber: '',
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),
        },

        created() {
            if (this.$_me.id) {
                this.firstName = this.$_me.first_name;
                this.lastName = this.$_me.last_name;
                this.contactNumber = this.$_me.contact_number;
            }
        },
    };
